/* globals $ */
import Component from './component';
import fromHtml from '../utils/from-html';
import urlParams from '../utils/url-params';

/* eslint-disable react/prefer-stateless-function, react/sort-comp */

const defaults = {};

export default class CategoryTags extends Component {
  constructor($context, options) {
    super(defaults, options);

    this.$context = $context;

    // Wyciąganie elementów z DOM po atrybucie ref przykladowo showMoreButton
    const {
      tags,
    } = fromHtml(this.$context[0]);

    this.$tags = $(tags);

    this.init();
  }

  init() {
    this.initTagsClick();
    this.initTagsState();
  }

  initTagsClick() {
    this.$tags.on('click', e => {
      e.preventDefault();
      $(e.target).toggleClass('active');
      this.fire('change', this.getActiveTags());

      return false;
    });
  }

  initTagsState() {
    const params = urlParams.get(window.location.href);

    if(params.subcategory) {
      const subcategories = params.subcategory.split(',');

      this.$tags.each((index, tag) => {
        const $tag = $(tag);
        const subcategoryId = $tag.attr('data-segment');

        if(subcategories.includes(subcategoryId)) {
          $tag.addClass('active');
        } else {
          $tag.removeClass('active');
        }
      });
    }
  }

  getActiveTags() {
    return this.$tags.filter('.active').map((index, tag) => tag.getAttribute('data-segment')).toArray() || [];
  }

  static initialize($context = $(document.body), options = {}) {
    return super.initialize('.js-category-tags', CategoryTags, 'CategoryTags', $context, options);
  }

}



// WEBPACK FOOTER //
// ./front/bankomania/js/components/category-tags.js